import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Text } from '@primer/react';
import CustomVideoPlayer from '../../../src/components/custom-video-player';
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/6cd2805e-0148-4a1d-b373-07acd1aa7f51",
        "alt": "The grid component applied to a section with different elements that spans in columns"
      }}></img></p>
    <h2>{`Usage`}</h2>
    <p>{`Use the grid component to define a layout that maintains consistent element positioning and sizing across pages. The grid is based on a 12-column layout and uses vertical and horizontal gaps to separate content units consistently`}<sup parentName="p" {...{
        "id": "fnref-1"
      }}><a parentName="sup" {...{
          "href": "#fn-1",
          "className": "footnote-ref"
        }}>{`1`}</a></sup>{`.`}</p>
    <p>{`Use the grid for general page layout, and grouping related elements with a similar purpose. E.g. A "contact us" form or a list of `}<a parentName="p" {...{
        "href": "/components/Card"
      }}>{`cards`}</a>{`.`}</p>
    <p>{`In most cases, we recommend using the same column span for each element to create a consistent layout.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/b4870b2e-5cf0-440c-9f51-0b1f81258b9b" alt="" />
    <Caption mdxType="Caption">
      Use the same column span for each content unit to create a consistent
      layout and spacing.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/0703ba43-7f47-4ad1-bc1d-020bc095e362" alt="" />
    <Caption mdxType="Caption">
      Don't use different column spans when grouping the same element type.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`Use different column spans instead of an even distribution when creating a visual hierarchy between items or when defining a general page or a section layout. E.g. A section with an `}<a parentName="p" {...{
        "href": "/components/Image"
      }}>{`image`}</a>{` and `}<a parentName="p" {...{
        "href": "/components/text"
      }}>{`text`}</a>{`, a layout with main content and a sidebar or a form with inputs and text areas.`}</p>
    <DoDontContainer stacked mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/bc442c41-3546-4341-bab3-1c649ccfe7d2" alt="" />
    <Caption mdxType="Caption">
      Use different column spans to create a visual hierarchy between a large
      image and text.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/f6307bee-3236-435a-a74d-b6d942a7925b" alt="" />
    <Caption mdxType="Caption">
      Don't span in few columns large images or long content text that will
      create unbalanced layouts.
    </Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer stacked mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/83e4eedf-5cc2-4dcc-a9dd-48d563744dd2" alt="" />
    <Caption mdxType="Caption">
      Use different column spans when you want to create a visual hierarchy on a
      section between different elements. Like a footer with notes and
      navigational lists.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/911a6b4b-791a-4186-8079-6296e17c65d0" alt="" />
    <Caption mdxType="Caption">
      Don't use equal column spans when the content is not related or the
      elements are different.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Responsive`}</h3>
    <p>{`The grid component provides control over the number of columns at each breakpoint. For most of the cases, we recommend using the same column span on each child at each breakpoint to create a consistent layout and spacing in all screen sizes.`}</p>
    <p>{`For example, a group of cards might span 3 columns on a extra large viewport, 4 columns on large viewports, 6 on medium and 12 columns on small viewports.`}</p>
    <div>
  <CustomVideoPlayer width="100%" src="https://github.com/primer/brand/assets/912236/a99beba9-b22f-4e2b-a5fa-66c2db246965" mdxType="CustomVideoPlayer" />
  <Caption mdxType="Caption">
    Use the same column span for each content unit at each breakpoint to create
    visually consistent layouts.
  </Caption>
    </div>
    <p>{`When using even column spans, we recommend to span each item full width on small viewports and stacking the items vertically to ensure that the content is readable and accessible on small screens.`}</p>
    <div>
  <CustomVideoPlayer width="100%" src="https://github.com/primer/brand/assets/912236/cd0d4335-03b2-48f2-98f0-2c53ef61544b" mdxType="CustomVideoPlayer" />
  <Caption mdxType="Caption">
    Use full width on small viewports to ensure that the content is readable and
    accessible.
  </Caption>
    </div>
    <h2>{`Grid vs Stack`}</h2>
    <p>{`We recommend using either the grid or stack component, depending on how the child items are displayed and how they work on different screen sizes. If the element is a sequential list of items in a vertical or horizontal order, we recommend using the stack component. Otherwise, if the element needs columns and rows or for general page layout, we recommend using the grid component instead`}<sup parentName="p" {...{
        "id": "fnref-2"
      }}><a parentName="sup" {...{
          "href": "#fn-2",
          "className": "footnote-ref"
        }}>{`2`}</a></sup>{`.`}</p>
    <h3>{`Grid examples`}</h3>
    <h4>{`Page or section layout`}</h4>
    <p>{`When defining the page or a section layout. E.g. A page with navigation, main content and footer areas.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/76e816de-1ec7-40c2-993f-61fe05f97656",
        "alt": null
      }}></img></p>
    <h4>{`Sub sections`}</h4>
    <p>{`When dividing an area into two areas. E.g. A "Send feedback" sidebar and a form, and the form uses the grid for the form layout itself.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/d617bfea-0758-4066-9ccc-7853eeb35cf3",
        "alt": null
      }}></img></p>
    <h4>{`Card or pillar grids`}</h4>
    <p>{`When laying out cards, pillars, or similar content-based elements.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/56dfbcd8-72ff-401c-a530-25f11f671f7f",
        "alt": null
      }}></img></p>
    <h3>{`Stack examples`}</h3>
    <h4>{`Navigation`}</h4>
    <p>{`For the page navigation or a list of links. E.g. Having a logo on the left side and the navigation on the right.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/022fc146-6286-4074-abc5-7341743da82e",
        "alt": null
      }}></img></p>
    <h4>{`List of actions`}</h4>
    <p>{`For a group of action or buttons, where items are displayed next to each other, and they are distributed horizontally or vertically, depending on the content length and the screen size.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/10ae15dd-f8f9-4174-9c89-2e9355120204",
        "alt": null
      }}></img></p>
    <h4>{`Form elements`}</h4>
    <p>{`For combinations of input fields with a button next to it.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/78a81f0e-55d5-4db5-8a8b-3184394fac51",
        "alt": null
      }}></img></p>
    <h4>{`Profile cards`}</h4>
    <p>{`For combinations of an avatar and descriptive content, where the information takes the remaining space from its parent element. This could be applied to any combinations of an icon and text too.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/c53f2ee7-93f1-416f-8fd5-bd965fd37f86",
        "alt": null
      }}></img></p>
    <h2>{`Accessibility`}</h2>
    <p>{`By default, the grid assumes that it will be used in a purely decorative fashion and thus sets no roles, ARIA attributes, or keyboard shortcuts. This is equivalent to having a sequence of `}<inlineCode parentName="p">{`<div>`}</inlineCode>{` elements on the page by default. Any interactive content within the grid should be given an appropriate accessibility treatment based on the specific workflow of your application.`}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Stack"
        }}>{`Stack`}</a>{`: To enable layout of its immediate children along the vertical or horizontal axis.`}</li>
    </ul>

    <div {...{
      "className": "footnotes"
    }}>
      <hr parentName="div"></hr>
      <ol parentName="div">
        <li parentName="ol" {...{
          "id": "fn-1"
        }}>{`The grid component is implemented using the `}<a parentName="li" {...{
            "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Grid_Layout"
          }}>{`CSS Grid Layout`}</a>{` specification.`}<a parentName="li" {...{
            "href": "#fnref-1",
            "className": "footnote-backref"
          }}>{`↩`}</a></li>
        <li parentName="ol" {...{
          "id": "fn-2"
        }}>{`This section is based on the article `}<a parentName="li" {...{
            "href": "https://ishadeed.com/article/grid-layout-flexbox-components/"
          }}>{`Grid for layout, Flexbox for components`}</a>{` by `}<a parentName="li" {...{
            "href": "https://github.com/shadeed"
          }}>{`@shadeed`}</a><a parentName="li" {...{
            "href": "#fnref-2",
            "className": "footnote-backref"
          }}>{`↩`}</a></li>
      </ol>
    </div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      